import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getProductOffInfo } from '../../../../api'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from '../../../components/icon/iconfont'
import { BigButton } from '../../../components/button'
import { FormattedMessage } from 'react-intl'
import { useQuery } from '../../../hooks/common'
import { action_fetch_activity_promotional } from '../../../../store/actions/global'
import { useDispatch } from 'react-redux'

import { unitPrice } from '../../../../utils/product'

export default props => {
    useStyles(classes)

    const [data, setData] = useState(null)
    const global = useSelector(state => state.global)
    const { promotionalActivity } = global;
    const query = useQuery()
    const dispatch = useDispatch();

    useEffect(async () => {
        if(query?.productId && query?.activityId){
            // const response = await getProductOffInfo(query?.productId)
            // if (response?.code === 200) {
            //     const result = response.result
            //     setData(result?.find?.(p => p.id === query?.activityId))
            // }

            await dispatch(action_fetch_activity_promotional(query?.productId, query?.activityId));
        }
    }, [])


    return promotionalActivity ? <div className={classes.BottomTools}>
        <div className={classes.Tip}>
            <span className={classes.Title}>{promotionalActivity?.title}</span>
            <span className={classes.Description}>{promotionalActivity?.description}</span>
        </div>
        <div className={classes.ToolsContainer}>
            <div className={classes.Tools}>
                <span className={classes.CartIcon}>
                    <Iconfont className={classes.Cart}>&#xe7b2;</Iconfont>

                    {
                        promotionalActivity?.shoppingCartProductCount > 0 && <span className={classes.Count}>{promotionalActivity?.shoppingCartProductCount}</span> 
                    }
                   
                </span>

                {
                    (promotionalActivity?.totalAmount || promotionalActivity?.saveAmount) && <React.Fragment>
                        <div className={classes.PricesContainer}>
                            {
                                promotionalActivity?.totalAmount && <p className={classes.TotalPrice}><FormattedMessage id="total" defaultMessage="Total" />: {unitPrice(promotionalActivity?.totalAmount)}</p>
                            }
                            
                            {
                                promotionalActivity?.saveAmount && <p className={classes.SavePrice}><FormattedMessage id="save" defaultMessage="Save" />: {unitPrice(promotionalActivity?.saveAmount)}</p>
                            }
                            
                        </div>
                    </React.Fragment>
                }
                

                <BigButton className={classes.CartBtn} onClick={() => {window.location.href = '/cart'}}>
                    <FormattedMessage id="go_to_bag" defaultMessage="Go to Bag" />
                </BigButton>
            </div>
        </div>
    </div> : <React.Fragment />
}